import { createSlice } from "@reduxjs/toolkit";

const uiSlice = createSlice({
  name: "ui",
  initialState: {
    isLoading: false,
    theme: "dark",
    heading: "",
    isFormLoading: false,
    breadcrumb: [],
    modalStack: [],
    subHeadingDetails: {},
  },
  reducers: {
    setLoading(state, action) {
      state.isLoading = action.payload;
    },
    setTheme(state, action) {
      state.theme = action.payload;
    },
    setHeading(state, action) {
      state.heading = action.payload;
    },
    setFormSubmitLoading(state, action) {
      state.isFormLoading = action.payload;
    },
    addBreadcrumb(state, action) {
      state.breadcrumb = action.payload;
    },
    openModal(state, action) {
      state.modalStack.push(action.payload);
    },
    clearModalOption(state) {
      state.modalStack.pop();
    },
    clearAllModals(state) {
      state.modalStack = [];
    },
    clearUi(state) {
      state.isLoading = false;
      state.theme = "dark";
      state.heading = "";
      state.isFormLoading = false;
      state.breadcrumb = [];
      state.modalStack = [];
      state.subHeadingDetails = {};
    },
    setSubHeadingDetails(state, action) {
      state.subHeadingDetails = action.payload;
    },
  },
});

export const uiActions = uiSlice.actions;
export default uiSlice;
